import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HelpersService } from '../../../services/helpers.service';
import { PaymentService } from '../../../services/payment.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cancel-package',
  templateUrl: './cancel-package.component.html',
  styleUrls: ['./cancel-package.component.scss']
})
export class CancelPackageComponent implements OnInit {
  @Input() chosenPackage;

  constructor(
    public router: Router,
    public modal: NgbActiveModal,
    public helpersService: HelpersService,
    public paymentService: PaymentService
  ) {}

  ngOnInit() {}

  cancelPackage() {
    const partnerId = this.helpersService.getPartnerId();
    this.paymentService.postCancelSubscription(partnerId).subscribe(res => {
      this.helpersService.removeTokenAndLogout();
      this.router.navigateByUrl('/');
      this.modal.close();
    });
  }
}
